import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { Colour } from 'components/variables'
import BrokePage from '../../pages/entries/brokePage'
import BucketListPage from '../../pages/entries/BucketListPage'
import ThemeOfTheMonthPage from '../../pages/entries/ThemeOfTheMonthPage'
import EscapeTourPage from '../../pages/entries/EscapeTourPage'
import FoodLoversPage from '../../pages/entries/FoodLoversPage'
import InControlPage from '../../pages/entries/inControlPage'
import lastMinutePage from '../../pages/entries/lastMinutePage'
import NewCitiesPage from '../../pages/entries/newCitiesPage'
import SummerHolidayPage from '../../pages/entries/summerHolidayPage'
import VoorJaarPage from '../../pages/entries/voorjaarPage'
import { getCountDownNumber } from '../../utils/entries'
import { getCdnUrl } from '../api/cdn'
import { destinationEnum } from '../models/funnelOrder/destination'
import { roomType } from '../models/funnelOrder/roomType'
import { Theme } from '../models/funnelOrder/theme'
import { IncomingTime, OutgoingTime } from '../models/funnelOrder/times'
import { Entry, EntryCategory, EntryKey, EntryType } from './types'

export const flyEntries: Entry[] = [
  {
    name: 'Beste prijs',
    order: {
      dk: 105.5,
    },
    key: EntryKey.goedkoopste,
    type: EntryType.Preset,
    active: true,
    colour: Colour.orange,
    theme: Theme.fly,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'beste-prijs-content',
      photoWebp: getCdnUrl('card-besteprijs.webp'),
      photo: getCdnUrl('card-besteprijs.jpg'),
      icon: SRPRS.thumbsup,
    },
    page: {
      name: 'beste-prijs',
      url: {
        // nl: 'beste-prijs',
        // be: 'beste-prijs',
        // uk: 'best-price',
        // ie: 'best-price',
        dk: 'best-price',
      },
      params: {
        theme: Theme.fly,
        destination: destinationEnum.allOfEurope,
        days: 3,
        locations: 1,
        roomType: roomType.budget,
        incomingTime: IncomingTime.WholeDay,
        outgoingTime: OutgoingTime.WholeDay,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      allowedParams: {
        incomingTime: [IncomingTime.WholeDay],
        outgoingTime: [OutgoingTime.WholeDay],
      },
      cheapest: true,
      photos: {
        alt: 'Beste Prijs Vliegreis - man met rugzak voor een monument',
        src: getCdnUrl('6._goedkoopste-768.jpg'),
        src1024: getCdnUrl('4._goedkoopste-1024.jpg'),
        src1280: getCdnUrl('3._goedkoopste-1280.jpg'),
        src1600: getCdnUrl('2._goedkoopste-1600.jpg'),
        src1920: getCdnUrl('1._goedkoopste-1920.jpg'),
      },
      style: {
        peopleNegative: true,
      },
    },
  },
  {
    name: 'Favoriet',
    key: EntryKey.popular,
    type: EntryType.Preset,
    order: {
      nl: 105,
      be: 105,
      uk: 105,
      ie: 105,
      dk: 105,
    },
    active: true,
    colour: Colour.lightPurple,
    theme: Theme.fly,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'favoriet-content',
      photoWebp: getCdnUrl('card-meestgeboekt.webp'),
      photo: getCdnUrl('card-meestgeboekt.jpg'),
      icon: SRPRS.heart,
    },
    page: {
      name: 'favoriet',
      url: {
        nl: 'favoriet',
        be: 'favoriet',
        uk: 'favourite',
        ie: 'favourite',
        dk: 'favourite',
      },
      params: {
        theme: Theme.fly,
        days: 4,
        locations: 1,
        destination: destinationEnum.allOfEurope,
        roomType: roomType.basic,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning],
      },
      cheapest: true,
      photos: {
        alt: 'Favoriet Vliegreis - man die van een rots de zee inspringt',
        src: getCdnUrl('6._popular-768.jpg'),
        src1024: getCdnUrl('4._popular-1024.jpg'),
        src1280: getCdnUrl('3._popular-1280.jpg'),
        src1600: getCdnUrl('2._popular-1600.jpg'),
        src1920: getCdnUrl('1._popular-1920.jpg'),
      },
      style: {
        navbarColor: 'black',
      },
    },
  },
  {
    name: 'Multi City',
    key: EntryKey.multicity,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 9,
      be: 9,
      uk: 6,
      dk: 6,
    },
    colour: Colour.mint2,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'multi-city-content',
      photoWebp: getCdnUrl('card-multicity.webp'),
      photo: getCdnUrl('card-multicity.jpg'),
      icon: SRPRS.aeroplanePlus,
    },
    page: {
      name: 'multi-city',
      url: {
        nl: 'multi-city',
        be: 'multi-city',
        uk: 'multi-city',
        dk: 'multi-city',
      },
      params: {
        theme: Theme.multiFly,
        days: 6,
        locations: 2,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        roomType: roomType.basic,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Morning, IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning, OutgoingTime.Afternoon],
      },
      cheapest: true,
      photos: {
        alt: 'Multi-City - stad met rivier vanuit de lucht',
        src: getCdnUrl('6._multicity-768.jpg'),
        src1024: getCdnUrl('4._multicity-1024.jpg'),
        src1280: getCdnUrl('3._multicity-1280.jpg'),
        src1600: getCdnUrl('2._multicity-1600.jpg'),
        src1920: getCdnUrl('1._multicity-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      content: {
        explainLeft: 6,
      },
    },
  },
  {
    name: 'Solo Together',
    key: EntryKey.solotogether,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 8,
      be: 8,
    },
    colour: Colour.bird,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'solo-together-content',
      photoWebp: getCdnUrl('card-solotogether.webp'),
      photo: getCdnUrl('card-solotogether.jpg'),
      icon: SRPRS.solotogether,
    },
    page: {
      name: 'solo-together',
      url: {
        nl: 'solo-together',
        be: 'solo-together',
      },
      params: {
        theme: Theme.solo,
        outgoingTime: OutgoingTime.MidLateMorning,
        incomingTime: IncomingTime.EarlyAfternoon,
        numberOfAdults: 1,
        numberOfChildren: 0,
        numberOfBabies: 0,
        days: 4,
        locations: 1,
        roomType: roomType.budget,
      },
      allowedParams: {
        incomingTime: [IncomingTime.EarlyAfternoon],
        outgoingTime: [OutgoingTime.MidLateMorning],
      },
      cheapest: true,
      photos: {
        alt: 'Solo Together - groep mensen die buiten rennen in de zon',
        src: getCdnUrl('totm-solotogether_INITIAL.jpg'),
        src768: getCdnUrl('totm-solotogether_TABLET.jpg'),
        src1024: getCdnUrl('totm-solotogether_DESKTOP.jpg'),
        src1600: getCdnUrl('totm-solotogether_CINEMADISPLAY.jpg'),
      },
      content: {
        topList: 4,
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
    },
  },
  {
    name: 'In Control',
    order: {
      nl: 4,
      be: 4,
      uk: 3,
      ie: 3,
      dk: 3,
    },
    key: EntryKey.incontrol,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.paleTurquoise,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'in-control-content',
      photoWebp: getCdnUrl('card-incontrol.webp'),
      photo: getCdnUrl('card-incontrol.jpg'),
      icon: SRPRS.sliders,
    },
    page: {
      name: 'in-control',
      url: {
        nl: 'in-control',
        be: 'in-control',
        uk: 'in-control',
        ie: 'in-control',
        dk: 'in-control',
      },
      params: {
        theme: Theme.incontrol,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        locations: 1,
        destination: destinationEnum.allOfEurope,
        days: 4,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning],
      },
      cheapest: true,
      photos: {
        alt: 'In Control - muur met abstracte graffiti tekening man',
        src: getCdnUrl('6._Heroshot-768.jpg'),
        src1024: getCdnUrl('4._Heroshot-1024.jpg'),
        src1280: getCdnUrl('3._Heroshot-1280.jpg'),
        src1600: getCdnUrl('2._Heroshot-1600.jpg'),
        src1920: getCdnUrl('1._Heroshot-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: InControlPage,
    },
  },
  {
    name: 'BucketList',
    order: {
      nl: 1,
      be: 1,
      uk: 1,
      ie: 1,
      dk: 1,
    },
    key: EntryKey.bucketList,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.glory,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'bucket-list-content',
      photoWebp: getCdnUrl('bucketlist-entry-card-bg.webp'),
      photo: getCdnUrl('bucketlist-entry-card-bg.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'bucket-list',
      url: {
        nl: 'bucket-list',
        be: 'bucket-list',
        uk: 'bucket-list',
        ie: 'bucket-list',
        dk: 'bucket-list',
      },
      params: {
        theme: Theme.bucketList,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        locations: 1,
        destination: destinationEnum.allOfEurope,
        days: 4,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Morning, IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning, OutgoingTime.Afternoon],
      },
      cheapest: true,
      photos: {
        alt: 'Bucket list',
        src: getCdnUrl('bucket-logo-768.jpg'),
        src1024: getCdnUrl('bucket-logo-1024.jpg'),
        src1280: getCdnUrl('bucket-logo-1280.jpg'),
        src1600: getCdnUrl('bucket-logo-1600.jpg'),
        src1920: getCdnUrl('bucket-logo-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: BucketListPage,
    },
  },
  {
    name: 'FoodLovers',
    order: {
      nl: 2,
      be: 2,
      uk: 5,
      ie: 5,
      dk: 5,
    },
    key: EntryKey.foodLoversFly,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.lightTomato,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'food-lovers-fly-content',
      photoWebp: getCdnUrl('food-lovers-entry-card-bg.webp'),
      photo: getCdnUrl('food-lovers-entry-card-bg.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'food-lovers-fly',
      url: {
        nl: 'food-lovers-fly',
        be: 'food-lovers-fly',
        uk: 'food-lovers-fly',
        ie: 'food-lovers-fly',
        dk: 'food-lovers-fly',
      },
      params: {
        theme: Theme.foodLoversFly,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        locations: 1,
        destination: destinationEnum.allOfEurope,
        days: 3,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Morning, IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning, OutgoingTime.Afternoon],
      },
      cheapest: true,
      photos: {
        alt: 'Food Lovers',
        src: getCdnUrl('foodlovers-logo-768.jpg'),
        src1024: getCdnUrl('foodlovers-logo-1024.jpg'),
        src1280: getCdnUrl('foodlovers-logo-1280.jpg'),
        src1600: getCdnUrl('foodlovers-logo-1600.jpg'),
        src1920: getCdnUrl('foodlovers-logo-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: FoodLoversPage,
    },
  },
  {
    name: 'Escape Tour',
    order: {
      nl: 7,
      be: 7,
    },
    key: EntryKey.escapeTour,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.lightTomato,
    theme: Theme.fly,
    // expiry: '2020-09-30',
    category: [EntryCategory.originals],
    // countDownNumber: getCountDownNumber(177, '2020-04-06', new Date()),
    // countDownStartNumber: 177,
    card: {
      contentKey: 'escape-tour-content',
      photoWebp: getCdnUrl('escape-entry-card-bg.webp'),
      photo: getCdnUrl('escape-entry-card-bg.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'escape-tour',
      url: {
        nl: 'escape-trip',
        be: 'escape-trip',
      },
      params: {
        theme: Theme.escapeTour,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        locations: 1,
        destination: destinationEnum.allOfEurope,
        days: 4,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning],
      },
      photos: {
        alt: 'Escape Room',
        src: getCdnUrl('escape-logo-768.jpg'),
        src1024: getCdnUrl('escape-logo-1024.jpg'),
        src1280: getCdnUrl('escape-logo-1280.jpg'),
        src1600: getCdnUrl('escape-logo-1600.jpg'),
        src1920: getCdnUrl('escape-logo-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: EscapeTourPage,
    },
  },
  {
    name: 'Zonvoordeel',
    key: EntryKey.voorjaar,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 105,
      be: 105,
      uk: 105,
    },
    colour: Colour.lightBlue,
    expiry: '2019-03-06',
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'zon-voordeel',
      photoWebp: getCdnUrl('card-zonvoordeel.webp'),
      photo: getCdnUrl('card-zonvoordeel.jpg'),
      icon: SRPRS.sun,
    },
    page: {
      name: 'voor-jaar-actie',
      url: {
        nl: 'citytrip-voorjaar',
        be: 'citytrip-voorjaar',
        uk: 'citybreak-spring',
      },
      params: {
        theme: Theme.zonvoordeel,
        departureDate: null,
        outgoingTime: OutgoingTime.Morning,
        incomingTime: IncomingTime.Afternoon,
        locations: 1,
        destination: destinationEnum.southEurope,
        roomType: roomType.basic,
        days: 3,
        year: 2019,
        month: 2,
      },
      allowedParams: {
        incomingTime: [IncomingTime.Afternoon],
        outgoingTime: [OutgoingTime.Morning],
      },
      cheapest: true,
      photos: {
        src: getCdnUrl('Voorjaar-MOBILE.jpg'),
        src768: getCdnUrl('Voorjaar-TABLET.jpg'),
        src1024: getCdnUrl('Voorjaar-DESKTOP.jpg'),
        src1600: getCdnUrl('Voorjaar-DISPLAY.jpg'),
      },
      style: {
        navbarColor: 'black',
      },
      overridePage: VoorJaarPage,
    },
  },
  {
    name: 'New Places',
    key: EntryKey.newCities,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 3,
      be: 3,
      uk: 2,
      ie: 2,
      dk: 2,
    },
    colour: Colour.celadon,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'new-cities',
      photoWebp: getCdnUrl('card-newplaces.webp'),
      photo: getCdnUrl('card-newplaces.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'explore-new-cities',
      url: {
        nl: 'nieuwe-bestemmingen',
        be: 'nieuwe-bestemmingen',
        uk: 'new-places',
        ie: 'new-places',
        dk: 'new-places',
      },
      params: {
        theme: Theme.newplaces,
        destination: destinationEnum.allOfEurope,
        outgoingTime: OutgoingTime.LateMorning,
        incomingTime: IncomingTime.MidAfternoon,
        days: 3,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.MidAfternoon],
        outgoingTime: [OutgoingTime.LateMorning],
      },
      photos: {
        alt: 'New Places - twee lachende vrouwen die elkaars ogen bedekken',
        src: getCdnUrl('6._Explore-New-Cities-768.jpg'),
        src1024: getCdnUrl('4._Explore-New-Cities-1024.jpg'),
        src1280: getCdnUrl('3._Explore-New-Cities-1280.jpg'),
        src1600: getCdnUrl('2._Explore-New-Cities-1600.jpg'),
        src1920: getCdnUrl('1._Explore-New-Cities-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: NewCitiesPage,
    },
  },
  {
    name: 'Broke',
    key: EntryKey.broke,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 0.01,
      be: 0.01,
      uk: 0.01,
      ie: 0.01,
    },
    colour: Colour.lightTurquoise,
    theme: Theme.fly,
    startFrom: '2020-02-14',
    expiry: '2020-02-24',
    category: [EntryCategory.originals],
    countDownNumber: getCountDownNumber(120, '2020-02-15', new Date(), 10),
    countDownStartNumber: 120,
    card: {
      contentKey: 'broke',
      photoWebp: getCdnUrl('feeling-lucky-card-bg-center.webp'),
      photo: getCdnUrl('feeling-lucky-card-bg-center.jpg'),
      icon: SRPRS.knobs,
    },
    page: {
      name: 'broke',
      url: {
        nl: 'broke',
        be: 'broke',
        uk: 'broke',
        ie: 'broke',
      },
      params: {
        theme: Theme.broke,
        destination: destinationEnum.allOfEurope,
        outgoingTime: OutgoingTime.WholeDay,
        incomingTime: IncomingTime.WholeDay,
        days: 3,
        roomType: roomType.budget,
      },
      allowedParams: {
        incomingTime: [IncomingTime.WholeDay],
        outgoingTime: [OutgoingTime.WholeDay],
      },
      photos: {
        alt: '',
        src: getCdnUrl('feeling-lucky-top-header-768.jpg'),
        src1024: getCdnUrl('feeling-lucky-top-header-1024.jpg'),
        src1280: getCdnUrl('feeling-lucky-top-header-1280.jpg'),
        src1600: getCdnUrl('feeling-lucky-top-header-1600.jpg'),
        src1920: getCdnUrl('feeling-lucky-top-header-1920.jpg'),
      },
      style: {
        navbarColor: 'black',
        headingColor: 'black',
      },
      overridePage: BrokePage,
    },
  },
  {
    name: 'Summer Holiday',
    key: EntryKey.summerHoliday,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 6,
      be: 6,
      uk: 4,
      ie: 4,
      dk: 4,
    },
    colour: Colour.golden,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'summer-holiday',
      photoWebp: getCdnUrl('6._summer-768.webp'),
      photo: getCdnUrl('6._summer-768.webp'),
      icon: SRPRS.sun,
    },
    page: {
      name: 'summer-holiday-entry',
      url: {
        nl: 'zomer-vakantie',
        be: 'zomer-vakantie',
        uk: 'summer-holiday',
        ie: 'summer-holiday',
        dk: 'summer-holiday',
      },
      params: {
        theme: Theme.summerHoliday,
        destination: destinationEnum.allOfEurope,
        outgoingTime: OutgoingTime.LateMorning,
        incomingTime: IncomingTime.EarlyAfternoon,
        days: 5,
        roomType: roomType.basic,
      },
      allowedParams: {
        incomingTime: [IncomingTime.EarlyAfternoon],
        outgoingTime: [OutgoingTime.LateMorning],
      },
      photos: {
        alt: 'Summer Holiday - prettige uitzicht van een zonnige stad',
        src: getCdnUrl('6._summer-768.jpg'),
        src1024: getCdnUrl('4._summer-1024.jpg'),
        src1280: getCdnUrl('3._summer-1280.jpg'),
        src1600: getCdnUrl('2._summer-1600.jpg'),
        src1920: getCdnUrl('1._summer-1920.jpg'),
      },
      style: {
        headingColor: 'white',
      },
      overridePage: SummerHolidayPage,
    },
  },
  {
    name: 'Last Minute',
    key: EntryKey.lastMinute,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 10,
      be: 10,
    },
    colour: Colour.almond,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'last-minute',
      photoWebp: getCdnUrl('6._last-minute-768.webp'),
      photo: getCdnUrl('6._last-minute-768.jpg'),
      icon: SRPRS.co2,
    },
    page: {
      name: 'last-minute-entry',
      url: {
        nl: 'last-minute',
        be: 'last-minute',
      },
      params: {
        theme: Theme.lastMinute,
        destination: destinationEnum.allOfEurope,
        outgoingTime: OutgoingTime.WholeDay,
        incomingTime: IncomingTime.WholeDay,
        days: 3,
        roomType: roomType.budget,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      allowedParams: {
        incomingTime: [IncomingTime.WholeDay],
        outgoingTime: [OutgoingTime.WholeDay],
      },
      photos: {
        alt: 'Last-Minute - mensen zitten in een infinity zwembad op zonsondergang',
        src: getCdnUrl('6._last-minute-768.jpg'),
        src1024: getCdnUrl('4._last-minute-1024.jpg'),
        src1280: getCdnUrl('3._last-minute-1280.jpg'),
        src1600: getCdnUrl('2._last-minute-1600.jpg'),
        src1920: getCdnUrl('1._last-minute-1920.jpg'),
      },
      style: {
        headingColor: 'white',
        navbarColor: 'white',
      },
      overridePage: lastMinutePage,
    },
  },
  {
    name: 'Thema van de Maand: Backpacking',
    key: EntryKey.themeOfTheMonth,
    type: EntryType.Flavour,
    active: true,
    order: {
      nl: 5,
      be: 5,
      uk: 5,
      ie: 5,
      dk: 5,
    },
    colour: Colour.coral,
    theme: Theme.fly,
    category: [EntryCategory.originals],
    card: {
      contentKey: 'theme-of-the-month-content',
      photoWebp: getCdnUrl('theme_of_the_month_2024_-_768x768.png'),
      photo: getCdnUrl('theme_of_the_month_2024_-_768x768.png'),
      icon: SRPRS.co2,
    },
    page: {
      name: 'theme-of-the-month',
      url: {
        nl: 'thema-van-de-maand',
        be: 'thema-van-de-maand',
        uk: 'theme-of-the-month',
        ie: 'theme-of-the-month',
        dk: 'theme-of-the-month',
      },
      params: {
        theme: Theme.themeOfTheMonth,
        destination: destinationEnum.allOfEurope,
        outgoingTime: OutgoingTime.WholeDay,
        incomingTime: IncomingTime.WholeDay,
        days: 3,
        roomType: roomType.budget,
        // year: new Date().getFullYear(),
        // month: new Date().getMonth() + 1,
      },
      allowedParams: {
        incomingTime: [IncomingTime.WholeDay],
        outgoingTime: [OutgoingTime.WholeDay],
      },
      photos: {
        alt: 'Last-Minute - mensen zitten in een infinity zwembad op zonsondergang',
        src: getCdnUrl('theme_of_the_month_2024_-_768x768.png'),
        src1024: getCdnUrl('theme_of_the_month_2024_-_1024x512.png'),
        src1280: getCdnUrl('theme_of_the_month_2024_-_1280x427.png'),
        src1600: getCdnUrl('theme_of_the_month_2024_-_1600x500.png'),
        src1920: getCdnUrl('theme_of_the_month_2024_-_1920x500.png'),
      },
      style: {
        headingColor: 'white',
        navbarColor: 'white',
      },
      overridePage: ThemeOfTheMonthPage,
    },
  },
]
